__turbopack_context__.v({
  "button": "fVNXkG_button",
  "buttonContent": "fVNXkG_buttonContent",
  "underline": "fVNXkG_underline",
});
